<template>
  <div>
    <b-modal
      hide-footer
      size="xl"
      no-close-on-esc
      id="galleryModal"
      ref="galleryModal"
      title="Select Image"
      no-close-on-backdrop
      @close="closeResetData"
    >
      <div class="w-100">
        <b-tabs
          content-class="mt-3"
          nav-wrapper-class="nav-tabs-justify-content-center"
        >
          <b-tab @click="selectedImage = null" title="Upload Image" active>
            <!-- FIRST SECTION WHILE SELECTION -->
            <div
              v-if="!gallery_image.image_setting_path"
              class="d-flex justify-content-center align-items-center flex-column"
              style="min-height: 250px"
            >
              <div class="row">
                <div class="col-12 d-flex justify-content-center">
                  <div class="input-material mb-2 mr-2 col-3">
                    <input
                      type="text"
                      v-model="set_width"
                      placeholder="Width"
                    />
                    <label>Width</label>
                  </div>
                  <div class="input-material mb-2 col-3">
                    <input
                      type="text"
                      v-model="set_height"
                      placeholder="Height"
                    />
                    <label>Height</label>
                  </div>
                </div>
              </div>
              <div>
                <label
                  for="uploadNewImage"
                  class="btn-outline-blue"
                  style="cursor: pointer"
                  >Upload Image</label
                >
                <p class="text-muted small"></p>
                <input
                  type="file"
                  v-on:change="setGalleryImage($event)"
                  class="d-none"
                  id="uploadNewImage"
                />
              </div>
            </div>

            <!-- AFTER UPLOAD SHOW BELOW DIV -->
            <div v-else class="row">
              <div class="col-7">
                <div class="col-6 text-center mx-auto">
                  <img
                    :src="_GetImagePath(gallery_image.image_setting_path)"
                    class="img-fluid"
                  />
                </div>
              </div>
              <div class="col-5 border-left">
                <!-- <div class="mb-4">
                  <button class="btn-outline-blue mx-0">Edit Image</button>
                </div>

                <div class="j-checkbox pl-0">
                  <b-form-checkbox value="orange">Save this image in gallery for future use</b-form-checkbox>
                </div>-->
                <!-- <div class="col-4 border-left"> -->
                <div class="row">
                  <div class="col-12 mb-4">
                    <div class="input-material">
                      <input v-model="image_name" type="text" placeholder="." />
                      <label>Image Name</label>
                    </div>
                  </div>

                  <div class="col-12 mb-4">
                    <div class="input-material">
                      <input
                        v-model="image_description"
                        type="text"
                        placeholder="."
                      />
                      <label>Description</label>
                    </div>
                  </div>

                  <div class="col-12">
                    <b-form-group label="Select Menu">
                      <!-- <div
                        class="j-radio pl-0 mb-2"
                        v-for="(menu,menuIndex) in menu_names"
                        :key="menuIndex"
                      >
                        <b-form-radio
                          v-model="selectedMenu"
                          @change="setCategoriesList($event)"
                          name="some-radios"
                          :value="menu"
                        >{{menu}}</b-form-radio>
                      </div>-->

                      <div class="j-radio pl-0 mb-2">
                        <b-form-radio
                          v-model="selectedMenu"
                          name="some-radios"
                          value="A"
                          @change="setCategoriesList($event)"
                          >Food & Beverages</b-form-radio
                        >
                      </div>

                      <div class="j-radio pl-0 mb-2">
                        <b-form-radio
                          v-model="selectedMenu"
                          name="some-radios"
                          value="B"
                          @change="setCategoriesList($event)"
                          >Movie Banners</b-form-radio
                        >
                      </div>
                      <div class="j-radio pl-0 mb-2">
                        <b-form-radio
                          v-model="selectedMenu"
                          name="some-radios"
                          value="C"
                          @change="setCategoriesList($event)"
                          >Cast & Crew</b-form-radio
                        >
                      </div>
                      <div class="j-radio pl-0 mb-2">
                        <b-form-radio
                          v-model="selectedMenu"
                          name="some-radios"
                          value="D"
                          @change="setCategoriesList($event)"
                          >Cinemas</b-form-radio
                        >
                      </div>
                      <div class="j-radio pl-0 mb-2">
                        <b-form-radio
                          v-model="selectedMenu"
                          name="some-radios"
                          value="F"
                          @change="setCategoriesList($event)"
                          >Cash Card</b-form-radio
                        >
                      </div>
                      <div class="j-radio pl-0 mb-2">
                        <b-form-radio
                          v-model="selectedMenu"
                          name="some-radios"
                          value="E"
                          @change="setCategoriesList($event)"
                          >Others</b-form-radio
                        >
                      </div>
                    </b-form-group>
                  </div>

                  <div
                    v-if="categories && categories.length > 0"
                    class="col-12 mb-4"
                  >
                    <div class="dropdown-curve-container">
                      <label
                        :class="
                          selected_category && selected_category.length > 0
                            ? 'shift-up'
                            : ''
                        "
                        >Select Category</label
                      >
                      <b-dropdown
                        variant="dropdown-curve"
                        :text="selected_category"
                        class="w-100"
                      >
                        <b-dropdown-item
                          v-on:click="selectCategory($event, category)"
                          v-for="(category, categoryIndex) in categories"
                          :key="categoryIndex"
                          >{{ category }}</b-dropdown-item
                        >
                        <!-- <b-dropdown-item>Second Action</b-dropdown-item>
                        <b-dropdown-item>Third Action</b-dropdown-item>-->
                        <!-- <b-dropdown-divider></b-dropdown-divider> -->
                      </b-dropdown>
                    </div>
                  </div>

                  <div
                    v-if="Languages && Languages.length > 0"
                    class="col-12 mb-4"
                  >
                    <div class="dropdown-curve-container">
                      <label :class="selected_language ? 'shift-up' : ''"
                        >Select Language</label
                      >
                      <b-dropdown
                        variant="dropdown-curve"
                        :text="selected_language"
                        class="w-100"
                      >
                        <b-dropdown-item
                          v-for="(lang, langIndex) in Languages"
                          :key="langIndex"
                          v-on:click="selectLanguage(lang)"
                          >{{ lang.lang_name }}</b-dropdown-item
                        >
                        <!-- <b-dropdown-item>Second Action</b-dropdown-item>
                        <b-dropdown-item>Third Action</b-dropdown-item>-->
                        <!-- <b-dropdown-divider></b-dropdown-divider> -->
                      </b-dropdown>
                      <!-- <p class="error_message">
                        <span v-if="submitted && !image_language"
                          >Please Select Language</span
                        >
                      </p> -->
                    </div>
                  </div>

                  <div class="col-12 mb-4">
                    <label class="mb-0">Link:</label>
                    <!-- <p class="mb-0">http://localhost/Brij/uploads/2020/04/Faviocn.png</p> -->
                    <p class="mb-0">
                      {{
                        gallery_image.image_setting_path
                          ? _GetImagePath(gallery_image.image_setting_path)
                          : "-"
                      }}
                    </p>
                  </div>

                  <div class="col-12 mb-4">
                    <p class="mb-0">
                      File Size:
                      <!-- <span class="font-weight-semi-bold">20mb</span> -->
                      <span class="font-weight-semi-bold"
                        >{{
                          img_details.size
                            ? (img_details.size / 1e6).toFixed(3)
                            : "0"
                        }}
                        mb</span
                      >
                    </p>
                  </div>
                  <div class="col-12 pt-3 text-center border-top px-0">
                    <!-- <button @click="$bvModal.hide('addImage')" class="btn-outline-blue">Cancel</button> -->
                    <span class="mx-1"></span>
                    <button
                      :disabled="btenable"
                      @click="submitInfo(1)"
                      class="btn-blue"
                    >
                      Save
                    </button>
                  </div>
                </div>
                <!-- </div> -->
              </div>
            </div>
            <div class="col-6 mx-auto text-center">
              <div class="mt-3"></div>
            </div>
          </b-tab>
          <b-tab :disabled="disableCancel" title="Image Gallery">
            <div class="row py-2">
              <div class="col-12 mb-4">
                <div class="input-material">
                  <input
                    autofocus
                    type="search"
                    placeholder="Search Image"
                    class="form-control form-control-sm col-4"
                    v-model="search_image_name"
                    v-debounce:300="getGalleryImages"
                  />
                  <label>Search Image</label>
                </div>
              </div>
              <div class="col-8 align-self-center">
                <div class="row align-items-center">
                  <div class="pl-3 font-weight-semi-bold">Filter by:</div>
                  <div
                    class="j-radio"
                    v-for="(menu, menuIndex) in menu_names"
                    :key="menuIndex"
                  >
                    <b-form-radio
                      v-model="selectedMenu"
                      @change="onSelectSearchMenu($event)"
                      name="some-radios"
                      :value="menu"
                      >{{ menu }}</b-form-radio
                    >
                  </div>
                </div>
              </div>
              <div class="col-4" v-if="categories && categories.length > 0">
                <div class="dropdown-curve-container">
                  <label
                    :class="
                      search_category && search_category.length > 0
                        ? 'shift-up'
                        : ''
                    "
                    >Select Category</label
                  >
                  <b-dropdown
                    variant="dropdown-curve"
                    :text="search_category"
                    class="w-100"
                  >
                    <b-dropdown-item
                      v-on:click="onSearchCategory($event, category)"
                      v-for="(category, categoryIndex) in categories"
                      :key="categoryIndex"
                      >{{ category }}</b-dropdown-item
                    >
                    <b-dropdown-item
                      v-on:click="onSearchCategory($event, 'All')"
                      >All</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
              </div>

              <div class="col-12">
                <hr />
              </div>
            </div>

            <div class="row justify-content-center">
              <!--  -->
              <div
                v-if="images_list.length <= 0"
                class="col-12 d-flex align-items-center justify-content-center"
                style="height: 250px"
              >
                <div class="text-center">
                  <img
                    src="@/assets/img/icons/no-image.svg"
                    height="60"
                    width="60"
                  />
                  <p class="text-muted mt-2">
                    Sorry, you do not have any images in the gallery,
                    <br />please upload of few images to the gallery.
                  </p>
                </div>
              </div>
              <div
                class="m-3"
                v-for="(images, imgKey) in images_list"
                :key="imgKey"
              >
                <!-- ADD CLASS 'selected' FOR SELECTION -->
                <div
                  class="gallery-image-placeholder"
                  :class="
                    selectedImage && selectedImage == images ? 'selected' : ''
                  "
                >
                  <!-- <img src="@/assets/img/temp/movie.jpg" class="image-fluid" /> -->
                  <img
                    @click="selectImage(images)"
                    :src="`${images.base_url}${images.image_path}`"
                    class="img-fluid"
                  />
                </div>
              </div>
            </div>
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              @change="onChangePagination($event)"
              :per-page="perPage"
              aria-controls="my-table"
            ></b-pagination>
          </b-tab>
          <!-- <b-tab title="Specify Image Resolution">
            <div class="col-6">
              <div class="input-material mb-2">
                <input type="text" v-model="set_width" placeholder="Width" />
              </div>
              <div class="input-material mb-2">
                <input type="text" v-model="set_height" placeholder="Height" />
              </div>
            </div>
            <div class="text-center">
              <div
                v-if="!gallery_image.image_setting_path"
                class="d-flex justify-content-center align-items-center"
                style="min-height: 250px"
              >
                <div>
                  <label
                    for="uploadNewImage"
                    class="btn-outline-blue"
                    style="cursor: pointer"
                    >Upload Image</label
                  >
                  <p class="text-muted small"></p>
                  <input
                    type="file"
                    v-on:change="setGalleryImage($event)"
                    class="d-none"
                    id="uploadNewImage"
                  />
                </div>
              </div>
            </div>
          </b-tab> -->
        </b-tabs>
      </div>

      <footer class="pt-3 border-top text-center mt-3">
        <button
          :class="disableCancel ? 'd-none' : ''"
          @click="
            $bvModal.hide('galleryModal');
            selectedImage = null;
          "
          class="btn-outline-blue"
        >
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          v-if="selectedImage && disableConfirm == false"
          @click="
            setFinalImagePath({ path: selectedImage.image_path, flag: 2 });
            selectedImage = null;
          "
          class="btn-blue"
        >
          Confirm
        </button>
        <button v-if="selectedImage" @click="cropFunction()" class="btn-blue">
          Crop Image
        </button>
      </footer>
    </b-modal>

    <!-- IMAGE MODAL -->
    <b-modal
      ref="preview-modal"
      id="selected-image-preview-modal"
      size="lg"
      hide-header
      hide-footer
    >
      <label class="h4 mt-2 mb-4 text-center">{{ tempModalImageName }}</label>
      <button
        class="btn-modal-close"
        @click="$bvModal.hide('selected-image-preview-modal')"
      >
        &times;
      </button>
      <img :src="_GetImagePath(tempModalImagePath)" class="img-fluid" />
    </b-modal>
    <!-- IMAGE CROPPER -->
    <b-modal
      id="imagecropper"
      title="Crop Image"
      hide-footer
      no-close-on-backdrop
      @hide="hideCropperModal()"
    >
      <button
        class="btn-modal-close btn-custom-modal"
        v-on:click="hideCropperModal()"
      >
        ✖
      </button>

      <vue-cropper
        ref="cropper"
        :src="imgSrc"
        :viewMode="1"
        :aspect-ratio="set_width / set_height"
        :autoCropBoxWidth="set_width"
        :autoCropBoxHeight="set_height"
        :cropBoxResizable="cropSizeResizable"
        dragMode="none"
        alt="Source Image"
        preview=".preview"
      ></vue-cropper>

      <br />
      <percentage-loader
        v-if="showPercentageLoader"
        :completed="percentageUploaded"
      />
      <br />
      <div class="text-center">
        <button
          :disabled="btenable"
          class="btn-blue"
          @click.prevent.stop="cropImage"
        >
          Save
        </button>
        <button v-if="set_rotate" class="btn-blue" @click.prevent.stop="rotate">
          Rotate
        </button>
      </div>
    </b-modal>

    <!-- GALLERY IMAGE MODAL -->
    <b-modal
      ref="preview-modal"
      id="selected-image-preview-modal"
      size="lg"
      hide-header
      hide-footer
    >
      <label class="h4 mt-2 mb-4 text-center">{{ tempModalImageName }}</label>
      <button
        class="btn-modal-close"
        @click="$bvModal.hide('selected-image-preview-modal')"
      >
        &times;
      </button>
      <img :src="_GetImagePath(tempModalImagePath)" class="img-fluid" />
    </b-modal>
    <!--GALLERY IMAGE CROPPER -->
    <b-modal
      id="galleryimagecropper"
      title="Crop Image"
      hide-footer
      no-close-on-backdrop
      @hide="hideGalleryCropperModal()"
    >
      <button
        class="btn-modal-close btn-custom-modal"
        v-on:click="hideGalleryCropperModal()"
      >
        ✖
      </button>

      <!-- <label class="h4 mt-2 mb-4 text-center">Crop Image</label> -->

      <div class="row">
        <div class="col-12 d-flex justify-content-center">
          <div class="input-material mb-2 mr-2 col-3">
            <input
              type="text"
              v-model="set_width"
              placeholder="Width"
              @input="cropFunction"
            />
            <label>Width</label>
          </div>
          <div class="input-material mb-2 col-3">
            <input
              type="text"
              v-model="set_height"
              placeholder="Height"
              @input="cropFunction"
            />
            <label>Height</label>
          </div>
        </div>
      </div>
      <vue-cropper
        v-if="isCropSet"
        ref="gallerycropper"
        :src="imgSrc"
        :viewMode="1"
        :aspect-ratio="set_width / set_height"
        :minCropBoxWidth="set_width"
        :minCropBoxHeight="set_height"
        :cropBoxResizable="true"
        dragMode="none"
        alt="Source Image"
        preview=".preview"
      ></vue-cropper>
      <br />

      <percentage-loader
        v-if="showPercentageLoader"
        :completed="percentageUploaded"
      />
      <br />

      <div class="text-center">
        <button
          :disabled="btenable"
          class="btn-blue"
          @click.prevent.stop="galleryCropImage"
        >
          Save
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { mapState, mapGetters, mapActions } from "vuex";
import PercentageLoader from "../../Partials/percentageLoader.vue";

export default {
  components: { VueCropper, PercentageLoader },
  props: {
    set_rotate: {
      type: Boolean,
      default: false
    },
    set_height: Number,
    set_width: Number,
    openModal: Boolean,
    cropSizeResizable: {
      type: Boolean,
      default: true
    },
    propImageName: String,
    category: String,
    language: Object,
    menu: String,
    img_desc: String,
    showPercentageLoader: {
      type: Boolean,
      default: false
    },
    resetImgData: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loader: "",
      finalImageSet: "",

      btenable: false,
      disableConfirm: false,
      disableCancel: false,
      selectedImage: null,
      images_list: [],
      selectedMenu: "",
      gallery_image: {
        image_setting_name: "Gallery Image",
        image_setting_path: null,
        image_setting_static_path: "",
        image_setting_baseurl: "",
        image_setting_showpath: ""
      },
      file: null,
      filename: null,
      width: null,
      height: null,
      cropImg: null,
      tempModalImageName: null,
      tempModalImagePath: null,
      imgSrc: null,
      img_details: {
        height: null,
        width: null,
        size: null
      },
      galleryId: null,
      menu_names: [
        "Food & Beverages",
        "Movie Banners",
        "Cast & Crew",
        "Cinemas",
        "Cash Card",
        "Others"
      ],
      selected_category: "",
      categories: [],
      selected_language: "",
      image_language: "",
      Languages: [],
      image_name: "",
      image_description: "",
      img_path: null,
      base_url: null,
      perPage: 20,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [],
      //
      search_image_name: "",
      search_menu: "",
      search_category: "",
      checkCLoseModal: true,
      percentageUploaded: 0,
      submitted: false,
      set_img_width: 0,
      set_img_height: 0,
      isCropSet: true
    };
  },
  //   computed:{
  //       ...mapGetters(['openModal'])
  //   },

  mounted() {
    this.set_img_width = this.set_width;
    this.set_img_height = this.set_height;
    this.getviewingnumber();
    this.getGalleryImages();
    this.getLanguagesList();
    // let loader = this.$loading.show();
    this.setCategoriesList("B");
    this.selectedMenu = "B";
    this.categories = ["Movie Banner", "Movie Poster", "Movie Scene"];
    if (this.menu) {
      this.selectedMenu = this.menu;
      this.setCategoriesList(this.menu);
    }
    if (this.propImageName) {
      this.image_name = this.propImageName;
    }
    if (this.img_desc) {
      this.image_description = this.img_desc;
    }
    if (this.category) {
      this.selected_category = this.category;
    }
  },
  watch: {
    img_desc(newVal) {
      if (newVal) {
        this.image_description = newVal;
      }
    },
    set_height(newVal) {
      if (Number.isNaN(newVal)) {
        this.set_height = 240;
      } else {
        this.set_height = Number(this.set_height || 0);
      }
    },
    set_width(newVal) {
      if (Number.isNaN(newVal)) {
        this.set_width = 420;
      } else {
        this.set_width = Number(this.set_width || 0);
      }
    },
    menu(newVal) {
      if (newVal) {
        this.selectedMenu = newVal;
        this.setCategoriesList(newVal);
      }
    },
    language(newVal) {
      if (newVal) {
        this.selected_language = newVal.lang_name;
        this.image_language = newVal.lang_id;
      }
    },
    category(newVal) {
      console.log("selected category watch: ", newVal);
      if (newVal) {
        this.selected_category = newVal;
      }
    },
    // selectedMenu(newval){
    //   this.selected_category != newval ? this.selected_category = '': this.selected_category
    //    if(newval == 'Food & Beverages'){
    //       this.categories = ['Veg', 'Non Veg']
    //       console.log('categories :>> ', this.categories);
    //     }else if(newval == 'Movie Banners'){
    //       this.categories = ['Movie Banner','Movie Poster']
    //     }else if(newval == 'Cast & Crew'){
    //       this.categories = ['Actor','Director','Producer']
    //     }else if(newval == 'Cinemas'){
    //       this.categories = ['Cinema Logo']
    //     }
    // },

    search_image_name: function(newValue, oldValue) {
      if (String(newValue).length == 0) {
        this.search_image_name = "";
        this.getGalleryImages();
      }
    },
    openModal(newval) {
      this.$bvModal.show("galleryModal");
    },
    propImageName(newval) {
      console.log("newval 121:>> ", newval);
      if (newval) {
        this.image_name = newval;
      }
    }
  },
  methods: {
    set_img_res() {
      this.set_width = parseInt(this.img_set_width, 10);
      this.set_height = parseInt(this.img_set_height, 10);
      // this.galleryCropImage();
      // this.btenable = true;
      // this.$bvModal.show("galleryimagecropper");
    },
    setCropFunction() {
      this.$refs.gallerycropper.setCropBoxData({
        height: this.set_height,
        width: this.set_width
      });
      // this.cropFunction();
    },
    rotate() {
      this.$refs.cropper.rotate(90);
    },
    onUploadProgress: function(event) {
      const { loaded, total } = event;
      const percent = Math.floor((loaded / total) * 100);
      this.percentageUploaded = percent;
      console.log("percentage uploaded", this.percentageUploaded);
    },
    closeResetData() {
      this.submitted = false;
      if (this.checkCLoseModal) {
        this.finalImageSet = "";
        this.selectedImage = null;
        this.resetData();
        this.disableCancel = false;
      }
    },
    ...mapActions(["setFinalImagePath"]),
    selectImage(images) {
      this.selectedImage = images;
      var imgAspect =
        this.selectedImage.image_width / this.selectedImage.image_height;
      var requiredAspect = this.set_width / this.set_height;
      var diff = Math.abs(imgAspect - requiredAspect);
      console.log("imgAspect :>> ", imgAspect);
      console.log("requiredAspect :>> ", requiredAspect);
      console.log("diff :>> ", diff);
      if (diff > 0.02 || isNaN(diff)) {
        this.disableConfirm = true;
      } else {
        this.disableConfirm = false;
      }
      console.log("this.selectedImage :>> ", this.selectedImage);
      // this.setFinalImagePath({path:images.image_path,flag:2})
    },
    // setFinalImage(){
    //     this.setFinalImagePath()
    // },
    cropFunction() {
      let name = this.selectedImage.image_path.split("-");
      let name_new = this.selectedImage.image_path.split(".");
      this.filename = name[1] || "image." + name_new[1];
      console.log("this.filename :>> ", this.filename);
      this.imgSrc = `${this.selectedImage.base_url}${this.selectedImage.image_path}`;
      this.isCropSet = false;
      // this.$bvModal.hide("galleryimagecropper");
      this.$bvModal.show("galleryimagecropper");
      setTimeout(z => {
        this.isCropSet = true;
      }, 100);
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function(event) {
      this.currentPage = event;
      this.getGalleryImages();
    },
    // disableImage(image_id) {
    //   MasterService.DisableImage(image_id)
    //     .then(response => {
    //       const { data } = response;
    //       if (data && data.status) {
    //         this.$toasted.show("Image Disabled");
    //         this.getGalleryImages();
    //       } else {
    //         this.$toasted.show(data.message);
    //       }
    //     })
    //     .catch(error => {
    //       this.$toasted.show(error);
    //     });
    // },
    setCategoriesList(event) {
      console.log("event :>> ", event);
      this.selected_category = "";
      if (event == "Food & Beverages" || event == "A") {
        this.categories = ["Veg", "Non Veg"];
        console.log("categories :>> ", this.categories);
      } else if (event == "Movie Banners" || event == "B") {
        this.categories = ["Movie Banner", "Movie Poster", "Movie Scene"];
      } else if (event == "Cast & Crew" || event == "C") {
        this.categories = ["Actor", "Director", "Producer"];
      } else if (event == "Cinemas" || event == "D") {
        this.categories = ["Cinema Logo"];
      } else if (event == "Others" || event == "E") {
        this.categories = ["Generic"];
      } else if (event == "Cash Card" || event == "F") {
        this.categories = ["Cash Card"];
      }
    },
    // getImageDetails(image_id) {
    //   MasterService.GetImageDetails(image_id)
    //     .then(response => {
    //       const { data } = response;
    //       if (data && data.status && data.Records.length > 0) {
    //         this.selectedMenu = data.Records[0].menu_name;
    //         this.galleryId = data.Records[0].image_id;
    //         this.selected_category = data.Records[0].category;
    //         this.image_name = data.Records[0].image_name;
    //         this.image_description = data.Records[0].image_description;
    //         this.img_path = data.Records[0].image_path;
    //         this.base_url = data.Records[0].base_url;
    //         this.img_details.height = data.Records[0].image_height;
    //         this.img_details.width = data.Records[0].image_width;
    //         this.img_details.size = data.Records[0].image_size;
    //         this.$bvModal.show("editImage");
    //       } else {
    //         this.resetData();
    //         this.$toasted.show(data.message);
    //       }
    //     })
    //     .catch(error => {
    //       this.$toasted.show(error);
    //     });
    // },
    resetData() {
      this.submitted = false;
      if (this.resetImgData) {
        this.selectedMenu = "";
        this.selected_category = "";
        this.image_name = "";
        this.image_description = "";
      }
      this.galleryId = null;
      this.img_details = {
        height: null,
        width: null,
        size: null
      };
      this.gallery_image.image_setting_path = null;
    },
    submitInfo(flag) {
      this.submitted = true;

      if (this.galleryId) {
        this.btenable = true;

        if (
          this.selectedMenu &&
          this.selectedMenu.length > 0 &&
          this.selected_category &&
          this.selected_category.length > 0 &&
          this.image_name &&
          this.image_name.length > 0
        ) {
          let payload = {
            image_id: this.galleryId,
            menu_name: this.selectedMenu,
            category: this.selected_category,
            language_id: this.image_language || null,
            image_name: this.image_name,
            image_description:
              this.image_description && this.image_description.length > 0
                ? this.image_description
                : null
          };

          MasterService.UpdateImageDetails(payload)
            .then(response => {
              this.disableCancel = false;
              const { data } = response;
              if (data && data.status) {
                this.setFinalImagePath(this.finalImageSet);
                this.$bvModal.hide("galleryModal");
                this.getGalleryImages();
                this.resetData();
                if (flag == 1) this.$toasted.show("Image Added Successfully");
                else this.$toasted.show("Image Updated Successfully");
                this.btenable = false;
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        } else {
          this.btenable = false;
          this.$toasted.show("Please Enter all details");
        }
      } else {
        this.btenable = false;
        this.$toasted.show("Please Upload an Image");
      }
    },
    selectCategory(event, category) {
      this.selected_category = category;
      console.log("this.selected_category :>> ", this.selected_category);
    },
    selectLanguage(Langauge) {
      this.selected_language = Langauge.lang_name;
      this.image_language = Langauge.lang_id;
    },
    onSelectSearchMenu: function(event) {
      console.log("I am responsible");
      this.currentPage = 1;
      this.search_menu = event;
      this.setCategoriesList(event);
      this.getGalleryImages();
    },
    onSearchCategory: function(event, value) {
      this.search_category = value;
      if (value == "All") {
        this.getGalleryImages();
      } else {
        this.getGalleryImages();
      }
    },
    getLanguagesList: function() {
      return new Promise((resolve, reject) => {
        this.Languages = [];
        let payload = {
          tableName: "ms_language",
          lang_is_active: "Y"
        };
        MasterService.GetActiveList(payload)
          .then(response => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Languages = data.Records;
              resolve(this.Languages);
            } else {
              console.log("show error :", data.message);
            }
          })
          .catch(error => {
            console.log("show error :", error);
            reject(error);
          });
      });
    },
    getGalleryImages: function() {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        searchValue: this.search_image_name,
        menu: this.search_menu || null,
        category: this.search_category != "All" ? this.search_category : null
      };
      MasterService.GetGalleryImages(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.images_list = data.Records;
            this.rows = data.totalRows;
          } else {
            this.images_list = [];
            this.rows = 0;
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.images_list = [];
          this.rows = 0;
          this.$toasted.show(error);
        });
    },
    setGalleryImage: function(e) {
      this.file = e.target.files[0];
      this.filename = e.target.files[0]["name"];
      console.log("this.filename :>> ", this.filename);

      //   this.width = 592;
      //   this.height = 888;

      console.log("this.file", this.file);

      if (this.file.type.indexOf("image/") === -1) {
        this.$toasted.show("Please select an image file");
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();

        reader.onload = event => {
          this.imgSrc = event.target.result;
          if (this.file.type.indexOf("/gif") === -1) {
            this.$bvModal.show("imagecropper");
          } else {
            this.img_details.height = this.set_height;
            this.img_details.width = this.set_width;
            this.onFileUpload(this.file, this.filename);
          }
          e.target.value = "";
        };
        reader.readAsDataURL(this.file);
      } else {
        // alert("Sorry, FileReader API not supported");
      }
    },
    cropImage() {
      if (!this.showPercentageLoader) {
        this.loader = this.$loading.show();
      }
      this.btenable = true;
      // get image data for post processing, e.g. upload or setting image src
      let temp = this.$refs.cropper.getData(true);
      console.log("temp :>> ", temp);
      this.img_details.height = temp.height;
      this.img_details.width = temp.width;
      this.cropImg = this.$refs.cropper
        .getCroppedCanvas()
        .toDataURL("image/jpeg");
      // this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
      //   console.log(this.data);
      var block = this.cropImg.split(";");
      // Get the content type of the image
      var contentType = block[0].split(":")[1]; // In this case "image/gif"
      // get the real base64 content of the file
      var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
      // Convert it to a blob to upload
      var blob1 = this.b64toBlob(realData, contentType);
      console.log("blob1 :>> ", blob1);
      this.img_details.size = blob1.size;
      console.log("this.img_details :>> ", this.img_details);
      this.onFileUpload(blob1, this.filename);
    },
    galleryCropImage() {
      if (!this.showPercentageLoader) {
        this.loader = this.$loading.show();
      }
      // get image data for post processing, e.g. upload or setting image src
      let temp = this.$refs.gallerycropper.getData(true);
      console.log("temp :>> ", temp);
      this.img_details.height = temp.height;
      this.img_details.width = temp.width;
      this.cropImg = this.$refs.gallerycropper.getCroppedCanvas().toDataURL();
      // this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
      //   console.log(this.data);
      var block = this.cropImg.split(";");
      // Get the content type of the image
      var contentType = block[0].split(":")[1]; // In this case "image/gif"
      // get the real base64 content of the file
      var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
      // Convert it to a blob to upload
      var blob1 = this.b64toBlob(realData, contentType);
      console.log("blob1 :>> ", blob1);
      this.img_details.size = blob1.size;
      console.log("this.img_details :>> ", this.img_details);
      this.btenable = true;
      this.onGalleryFileUpload(blob1, this.filename);
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    onFileUpload: function(image, filename) {
      this.disableCancel = true;
      let formData = new FormData();
      formData.append("image", image, filename);
      formData.append("imagePath", "Gallery Image");
      formData.append("height", this.img_details.height);
      formData.append("width", this.img_details.width);
      formData.append("size", this.img_details.size);
      // formData.append("imagePath", PosterItem.image_setting_static_path);
      let options = {};
      if (this.onUploadProgress) {
        options.onUploadProgress = this.onUploadProgress;
      }
      MasterService.GlobalUploadImage(formData, options)
        .then(response => {
          const { data } = response;

          if (data && data.status) {
            this.$bvModal.hide("imagecropper");
            // this.MovieContentContainer[MovieContentIndex].moviePosters[
            //   PosterIndex
            // ].image_setting_path = data.path;
            this.onSetImagePath(data);
            this.finalImageSet = {
              path: data.path,
              flag: 1,
              finalHeight: this.img_details.height,
              finalWidth: this.img_details.width
            };

            this.galleryId = data.galleryId;
            this.$toasted.show(data.message);
            this.getGalleryImages();
            this.btenable = false;
          } else {
            this.btenable = false;
            data["message"] && data["message"]["message"]
              ? this.$toasted.show(data.message.message)
              : this.$toasted.show(
                  data.message ||
                    "Sorry! Something went wrong. kindly contact your administrator"
                );
          }
        })
        .catch(err => {
          this.btenable = false;
          this.disableCancel = false;
          this.$toasted.show(
            "Sorry! Something went wrong. kindly contact your administrator"
          );
        })
        .finally(() => {
          setTimeout(() => {
            if (this.loader) {
              this.loader.hide();
            }
          }, 1000);
        });
    },
    onGalleryFileUpload: function(image, filename) {
      //   let loader = this.$loading.show();
      console.log("gallery_upload");

      let formData = new FormData();
      formData.append("image", image, filename);
      formData.append("imagePath", "Gallery Image");
      formData.append("height", this.img_details.height);
      formData.append("width", this.img_details.width);
      formData.append("size", this.img_details.size);

      // formData.append("imagePath", PosterItem.image_setting_static_path);
      let options = {};
      if (this.onUploadProgress) {
        options.onUploadProgress = this.onUploadProgress;
      }
      MasterService.GlobalUploadImage(formData, options)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.setFinalImagePath({
              path: data.path,
              finalHeight: this.img_details.height,
              finalWidth: this.img_details.width,
              flag: 2
            });
            this.galleryId = data.galleryId;
            this.gallerySubmitInfo(data.galleryId);
            // this.$toasted.show(data.message)
            // this.getGalleryImages()
            // this.$bvModal.hide("galleryimagecropper");
            this.btenable = false;
          } else {
            this.btenable = false;
            data["message"] && data["message"]["message"]
              ? this.$toasted.show(data.message.message)
              : this.$toasted.show(
                  data.message ||
                    "Sorry! Something went wrong. kindly contact your administrator"
                );
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => this.loader.hide(), 1000);
        });
    },
    gallerySubmitInfo(galleryId) {
      console.log("image_gallery");
      if (galleryId) {
        let payload = {
          image_id: galleryId,
          menu_name: this.selectedImage.menu_name
            ? this.selectedImage.menu_name
            : null,
          category: this.selectedImage.category
            ? this.selectedImage.category
            : null,
          image_name: this.selectedImage.image_name
            ? this.selectedImage.image_name
            : null,
          image_description: this.selectedImage.image_description
            ? this.selectedImage.image_description
            : null
        };

        MasterService.UpdateImageDetails(payload)
          .then(response => {
            this.disableCancel = false;
            const { data } = response;
            if (data && data.status) {
              this.$bvModal.hide("galleryimagecropper");
              this.$bvModal.hide("galleryModal");
              this.resetData();
              this.$toasted.show("Image Added Successfully");
              this.getGalleryImages();
              this.btenable = false;
            } else {
              this.btenable = false;
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      } else {
        this.btenable = false;
        this.$toasted.show("Please Upload an Image");
      }
    },

    onSetImagePath: function(data, MovieContentIndex, PosterIndex) {
      this.gallery_image.image_setting_path = data.path;
    },
    openImageModal: function(image_name, image_path) {
      this.tempModalImagePath = image_path;
      this.tempModalImageName = image_name;
      this.$refs["preview-modal"].show();
    },
    hideCropperModal: function() {
      console.log("hideCropperModal called");
      this.percentageUploaded = 0;
      // this.$bvModal.hide("imagecropper");
    },
    hideGalleryCropperModal: function() {
      console.log("hideGalleryCropperModal called");
      this.percentageUploaded = 0;
      // this.$bvModal.hide("galleryimagecropper");
    }
  }
};
</script>

<style>
.image-gallery-table .image-placeholder {
  width: 75px;
  height: 75px;
  border-radius: 3px;
  overflow: hidden;
  border: 1px solid #fafafa;
  background-color: #f3f3f3;
}

.image-gallery-table .image-placeholder img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.image-gallery-table td {
  vertical-align: top;
  font-weight: normal !important;
  font-size: 14px;
}

.image-gallery-table th:last-child {
  padding-right: 50px;
}
.image-gallery-table th:last-child,
.image-gallery-table td:last-child {
  text-align: right;
}

.btn-modal-close-custom {
  top: 2.5px;
  right: 10px;
  font-size: 40px;
  position: absolute;
  z-index: 11;
}

.modal-header .close {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ImageGallery/imageGalleryModal.vue